import ko from 'knockout';
import templateMarkup from 'raw-loader!./assurance-alerts-view.html';
import _ from 'lodash';
import Signals from 'signals';
import Rx from '../../../../thirdPartyForks/rx.all';
import DateRangeModel from '../../../../components/dialBackInput/date-range-picker.model';
import DateRangeDataService from '../../../../components/dialBackInput/date-range-picker.service';
import MetadataService from '../../../../services/metadata.service';
import PreferenceService from '../../../../services/preference.service';
import FilterModel from '../../components/filter/data/filter.model';
import GridModel from '../../components/grid/data/grid.model';
import GridService from '../../components/grid/data/grid.service';
import DataProvider from "../../../../app/data-framework/data-provider";
import DataSecureService from "../../services/data-secure.service";
import Vue from "vue";
import vuetify from "../../../../plugins/vuetify";
import AlertFilters from "../../components/moi-filters/alertFilters.vue";
import DataTable from '../../../../vueComponents/dataTable/src/dataTable.vue';
import LoginService from "../../../../services/login.service";
import DashboardContainer from "../../../../vueComponents/dashboardContainer/src/dashboardContainer.vue";

var REFRESH_RATE_MS = 30 * 1000;

function AlertsView(params) {
  let self = this;
  self.initialize(params);
}

AlertsView.prototype = {
  dispose: function () {
    var self = this;
    window.editableBooleanToggle = undefined;
    _.forEach(self.subscriptions, function (subscription) {
      subscription.dispose();
    });
    if (self.vueComponents) {
      self.vueComponents.$destroy();
      self.vueComponents.$el.parentNode.removeChild(self.vueComponents.$el);
    }

  },

  getViewIds: function () {
    var self = this;
    return {
      appId: self.appId,
      viewId: self.viewId + '_' + ko.unwrap(self.datasetName)
    };
  },

  initialize: function (params) {
    var self = this;

    // this is a horrible hack used for the enabled column renderer
    window.editableBooleanToggle = function(field, cb, currentValue, id) {
      return DataSecureService.setMonitorEnabled(id, !currentValue)
      .then(function(results) {
        if (results && results.statusCleared) {
          // force a data update 
          let vueTable = ko.contextFor(document.getElementById("alert-view-table").children[0]).$component;

          if (vueTable) {
            vueTable.reloadDataFunc(); // note this may take a few seconds to load, so it won't change state right away
          }
        }
      })
      .catch(function (error) {
        // todo show error
        console.log(error);
        window.setTimeout(() => {
          cb.checked = currentValue;
        });
      });

    };

    self.filter = [];
    self.subscriptions = [];
    self.filterBreakdown = ko.observable({
      status: {
        Clear: 0,
        Critical: 0,
        Info: 0,
        Warn: 0,
      },
      enabled: {
        yes: 0,
        no: 0,
      },
      type: {
        event: 0,
        metric: 0,
      },
      cdr: {
        yes: 0,
        no: 0,
      },
      createdBy: {
        me: 0,
        others: 0,
      },
    });

    self.route = params.route;
    self.routeParams = ko.unwrap(_.get(params, 'routeParams'));

    self.datasetName = _.get(self, 'routeParams.datasetName');
    if (_.isEmpty(ko.unwrap(self.datasetName))) {
      throw new Error('Mandatory \'datasetName\' parameter is missing or empty.');
    }

    self.datasetViewContentElement = document.querySelector('.dataset-view-content');

    self.dataChangedCallback = self.dataChangedCallback.bind(self);
    self.dataLoadedCallback = self.dataLoadedCallback.bind(self);
    self.dataFilteredCallback = self.dataFilteredCallback.bind(self);

    self.appId = _.get(self, 'routeParams.appId', 'app');
    self.captureType = _.get(self, 'routeParams.type', 'page');
    self.hasDateRangePicker = _.get(self, 'routeParams.hasDateRangePicker', false);
    self.pageId = _.get(self, 'routeParams.pageId', 'dataset');
    self.title = _.get(self, 'routeParams.title', 'Dataset');
    self.viewId = _.get(self, 'routeParams.viewId', 'dataset');

    self.dateRangeModel = new DateRangeModel(self.appId);
    self.dateRangeService = new DateRangeDataService(self.dateRangeModel);
    self.isLiveMode = true;

    self.columnIdsToHide = [];
    self.datetimeRange = {};

    self.filterReadySignal = new Signals.Signal();
    self.gridReadySignal = new Signals.Signal();

    self.filterModel = new FilterModel(true, self.appId + self.pageId);

    self.gridModel = new GridModel();
    self.gridService = new GridService(self.gridModel);

    self.gridOptions = {
      filterReadySignal: self.filterReadySignal,
      filterModel: self.filterModel,
      gridReadySignal: self.gridReadySignal,
      gridModel: self.gridModel,
      gridService: self.gridService
    };

    self.filterModel.activeFiltersUpdated.add(self.updateQueryStringFromActiveFilters.bind(self));
    self.gridModel.headersNeedsSave.add(self.saveHeaderPreferences.bind(self));
    self.gridModel.sortingNeedsSave.add(self.saveSortingPreferences.bind(self));
    self.gridModel.paginationNeedsSave.add(self.savePaginationPreferences.bind(self));

    self.localData = ko.observableArray();

    self.initializeAlertFiltersView();
  },


  initializeAlertFiltersView: function() {
    let self = this;

    self.vueComponents = new Vue({
      el: '#vueComponents',
      vuetify,
      data: {
        breakdowns: self.filterBreakdown(),
        appId: ko.unwrap(self.appId),
        viewId: ko.unwrap(self.viewId),
        datasetName: ko.unwrap(self.datasetName),
        isLiveMode: ko.unwrap(self.isLiveMode),
        filter: self.filter,
        dateRange: self.datetimeRange,
        filterReadySignal: self.filterReadySignal,
        filterModel: self.filterModel,
        columnIdsToHide: self.columnIdsToHide,
        rowClickCallback: self.rowClickCallback,
        dataLoadedCallback: self.dataLoadedCallback,
        dataChangedCallback: self.dataChangedCallback,
        dataFilteredCallback: self.dataFilteredCallback,
      },
      components: {
        'alert-filters': AlertFilters,
        'data-table': DataTable,
      },
      methods: {
        updateFilters: function(newFilters) {
          self.filter = newFilters;
          this.filter = newFilters;
        },
      }
    });

    self.subscriptions.push(self.filterBreakdown.subscribe(() => {
      self.vueComponents.breakdowns = self.filterBreakdown();
    }))
  },


  koDescendantsComplete: function () {
    var self = this;

    DataProvider.getInstance().fetchAssuranceQueryServiceBaseURL().then((baseURL) => {
      MetadataService.fetchDatasetMetadataWithoutCategories().then(responseMetadata => {
        // setup filter model metadata
        self.datasetMetadata = _.find(responseMetadata, function (datasetMetadata) {
          return (datasetMetadata.name).toLowerCase() === ko.unwrap(self.datasetName).toLowerCase();
        });

        self.filterModel.setDatasetMetadata(self.datasetMetadata);

        self.loadPreferences().then(function () {
          self.gridService.setupComplete(); // call dataset.getInitialData

          if (!ko.unwrap(self.hasDateRangePicker)) {
            self.subscriptions.push(Rx.Observable.timer(REFRESH_RATE_MS, REFRESH_RATE_MS)
            .subscribe(function () {
              self.gridService.fetchDataset();
            }));
          }
        });
      });
    });
  },

  addMoi: function() {
    location.href = '#monitoring/moi/new';
  },

  processDataBreakdowns: function(data, visibleData) {
    let self = this;

    function breakdown(rows) {
      let breakdown = {
        status: {
          Clear: 0,
          Critical: 0,
          Info: 0,
          Warn: 0,
        },
        enabled: {
          yes: 0,
          no: 0,
        },
        type: {
          event: 0,
          metric: 0,
        },
        cdr: {
          yes: 0,
          no: 0,
        },
        createdBy: {
          me: 0,
          others: 0,
        },
      };
      _.forEach(rows, row => {
        breakdown.status[row.status]++;
        breakdown.enabled[row.enabled ? 'yes' : 'no']++;
        breakdown.cdr[row.cdr ? 'yes' : 'no']++;
        breakdown.type[row.category === 'event' ? 'event' : 'metric']++;
        breakdown.createdBy[row.createdBy === LoginService.userObject.userId ? 'me'
            : 'others']++;
      });
      return breakdown;
    }

    let breakdownAll = breakdown(data);
    let breakdownVisible = breakdown(visibleData);
    self.filterBreakdown(breakdownVisible);
  },

  dataChangedCallback: function(data, visibleData) {
    let self = this;
    self.processDataBreakdowns(data, visibleData);
  },

  dataLoadedCallback: function(data, visibleData) {
    let self = this;
    self.processDataBreakdowns(data, visibleData);
  },

  dataFilteredCallback: function(data, visibleData) {
    let self = this;
    self.processDataBreakdowns(data, visibleData);
  },



  // updates the query string to contain a representation of the active filters
  updateQueryStringFromActiveFilters: function() {
    var self = this;

    var href = window.location.href;

    // remove the existing filter parameter
    href = href.replace(/\b\?filter=[^&$]*/, '');

    var newFilter = self.filterModel.getActiveFiltersString();
    if (newFilter !== "") {
      href += "?filter=" + newFilter;
    }

    if (window.location.href !== href) {
      // replaceState allows us to change the URL without reloading the page
      window.history.replaceState("", null, href);
    }
  },

  // creates a list of active filters from the query string created in `updateQueryStringFromActiveFilters`
  createFiltersFromQueryString: function () {
    var self = this;
    var filterParam = _.get(self, 'routeParams["?query"].filter', '');
    if (filterParam === "") {
      return;
    }
    var createdFilters = self.filterModel.getFiltersFromString(filterParam);
    self.filterModel.setActiveFilters(createdFilters);
  },

  loadPreferences: async function () {
    let self = this;

    let viewIds = self.getViewIds();
    let metadata = await MetadataService.fetchDatasetMetadataWithoutCategories();
    let datasetMetadata = metadata.find(config => config.id.toLowerCase() === ko.unwrap(self.datasetName).toLowerCase());

    return PreferenceService
    .getDatasetViewPreferences(viewIds.appId, viewIds.viewId, datasetMetadata)
    .then(function (preferences) {
      self.createFiltersFromQueryString(); // dataset.updateGridServiceMetadata needs to have finished before this call
      var gridConfig = preferences.gridConfig || {};

      let columns = datasetMetadata.columns;

      let prefColumnRevision = 0;
      let newPrefColumnRevision = 0;
      if (!_.isEmpty(gridConfig) && gridConfig['columnRevision']) {
        prefColumnRevision = gridConfig['columnRevision'];
      }

      _.forEach(columns, col => {
        if (col.revision && col.revision > prefColumnRevision) {
          if (_.isEmpty(gridConfig) || !gridConfig.hiddenColumns) {
            gridConfig.hiddenColumns = [];
          }
          if (col['notShown']) {
            if ( !_.includes(gridConfig.hiddenColumns, col.id)) {
              gridConfig.hiddenColumns.push(col.id);
            }
            // todo support force showing a column with the code below
            // } else {
            //   if ( !_.includes(gridConfig.hiddenColumns, col.id)) {
            //     _.pull(gridConfig.hiddenColumns, col.id);
            //   }
          }
          newPrefColumnRevision = Math.max(newPrefColumnRevision, col.revision);
        }
      });

      if (newPrefColumnRevision) {
        PreferenceService.saveDatasetViewPreferences(viewIds.appId, viewIds.viewId, { gridConfig: { hiddenColumns: gridConfig.hiddenColumns, columnRevision: newPrefColumnRevision } });
      }


      if (!_.isEmpty(gridConfig)) {
        self.columnIdsToHide = gridConfig.hiddenColumns;
        if (self.vueComponents) {
          self.vueComponents.columnsToHide = gridConfig.hiddenColumns;
        }
        self.gridService.setHiddenHeaders(_.get(gridConfig, 'hiddenColumns', []));
        // todo do we load this from local storgage??
        // self.gridService.setPagination(_.get(gridConfig, 'pagination', {}));
        var sorting = _.get(gridConfig, 'sortModel', []);
        self.gridService.setSorting(sorting);

      }
    });
  },

  savePaginationPreferences:  function () {
    // var self = this;
    // var viewIds = self.getViewIds();
    // todo store in local storage??? there is no way for user to set page size, so no need to save that
    // it's really only the page number, but that doesn't make sense across runs, but maybe in local storage?
    // PreferenceService.saveDatasetViewPreferences(viewIds.appId, viewIds.viewId, { gridConfig: { pagination: self.gridService.getPagination() }});
  },

  saveSortingPreferences:  function () {
    var self = this;
    var viewIds = self.getViewIds();
    PreferenceService.saveDatasetViewPreferences(viewIds.appId, viewIds.viewId, { gridConfig: { sortModel: self.gridService.getSorting() }});
  },

  saveHeaderPreferences:  function () {
    var self = this;
    var viewIds = self.getViewIds();
    PreferenceService.saveDatasetViewPreferences(viewIds.appId, viewIds.viewId, { gridConfig: { hiddenColumns: self.gridService.getHiddenHeaders() }});
  },
}

// this component is directly registered at 'src/app/component-registration.js'
// since it is needed long before its parent module is loaded
export default {
  components: {DashboardContainer},
  template: templateMarkup, viewModel: AlertsView };
